import { fromJS } from 'immutable';
import * as ActionTypes from './constants';
import { DEFAULT_ACTIVE_BRANCH_ID } from '../../../constants/constants';

const isMobile = () =>
  /Mobile|Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
    navigator.userAgent
  );

const initialState = fromJS({
  loading: false,
  fetchedLoginItems: false,
  authenticationErrorMessage: '',
  selectedMenuItemIndex: 0,
  isMobileBrowser: isMobile(),
  deliveryFrequencies: [],
  branches: [],
  routes: [],
  districts: [],
  activeBranchId: DEFAULT_ACTIVE_BRANCH_ID,
  priceReasonCodes: [],
  appConfigs: []
});

function appReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.START_LOADING:
      return state.set('loading', true);
    case ActionTypes.STOP_LOADING:
      return state.set('loading', false);
    // Authentication process
    case ActionTypes.AUTHENTICATE_ERROR: {
      return state.set('authenticationErrorMessage', action.errorMessage);
    }
    case ActionTypes.SIGN_OUT:
      return initialState.set('authenticationErrorMessage', '');
    // End of Authentication process

    case ActionTypes.OPEN_MENU_ITEM:
      return state.set('selectedMenuItemIndex', action.item.id);

    case ActionTypes.STORE_LOGIN_ITEMS:
      const activeBranchId =
        action.branches.length !== 1
          ? DEFAULT_ACTIVE_BRANCH_ID
          : action.branches[0].branchId;
      return state
        .set('fetchedLoginItems', true)
        .set('deliveryFrequencies', action.deliveryFrequencies)
        .set('branches', action.branches)
        .set('routes', action.routes)
        .set('districts', action.districts)
        .set('activeBranchId', activeBranchId)
        .set('priceReasonCodes', action.priceReasonCodes)
        .set('appConfigs', action.appConfigs);

    case ActionTypes.STORE_ADMIN_SELECTED_BRANCHES:
      return state.set('branches', action.branches);
    case ActionTypes.SET_ACTIVE_BRANCH:
      return state.set('activeBranchId', action.branchId);
    case ActionTypes.UPDATE_APP_CONFIG:
      return state.set('appConfigs', action.appConfigs);
    default:
      return state;
  }
}

export default appReducer;
